import styled from 'vue-styled-components'

const Wrapper = styled.div`
position: relative;
height: 100%;
width: 100%;
z-index: 10;
.detail {
  background-color: #ffffff;
  color: #12A9FF;
  width: fit-content;
  padding: 4px 8px;
  position: absolute;
  border-radius: 4px;
}
.resize-dot{
  pointer-events: all;
  width: 8px;
  height: 8px;
  background-color: #ffffff;
  position: absolute;
  border: 1px solid #12A9FF;
  text-align : center;
  &.start {
    left: -2px;
    top: 28%;
  }
  &.end {
    right: -2px;
    top: 28%;
  }
  &.top {
    top: -2px;
    left: 6px;
  }
  &.bottom {
    bottom: -2px;
    left: 6px;
  }
  &.start, &.end {
    cursor: ew-resize;
  }
  &.top, &.bottom {
    cursor: ns-resize;
  }
}

`


export {
  Wrapper,
}